export const GA_TRACKING_ID = process.env.ENV === "production" ? "UA-47454572-4" : "UA-XXXXXXXX-X"
export const GTM_ID = process.env.ENV === "production" ? "GTM-MGFW44C" : "GTM-XXXXXXX"
export const GOP_ID = process.env.ENV === "production" ? "GTM-T6TM25V" : "GTM-XXXXXXX"

export const trackPageView = (url: string) => {
  if (typeof window !== "undefined") {
    try {
      window.gtag("config", GA_TRACKING_ID, {
        page_path: url,
      })
    } catch (error) {
      console.log("trackPageView error")
    }
  }
}

export const pushUserIdToDataLayer = (userId: number) => {
  if (typeof window !== "undefined") {
    try {
      window.dataLayer.push({
        user_id: userId,
      })
    } catch (error) {
      console.log("pushUserIdToDataLayer error")
    }
  }
}
